import FormattedMessage from 'I18n/components/FormattedMessage';
import { EXPIRING_SOON_NOTICE_IN_DAYS } from '../../constants/certifications';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const ExpiringSoonHelpIcon = () => {
  return /*#__PURE__*/_jsx(HelpIcon, {
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "learningCenter.myTeam.tableColumns.expiringSoonHelp",
      options: {
        count: EXPIRING_SOON_NOTICE_IN_DAYS
      }
    })
  });
};
export default ExpiringSoonHelpIcon;